import component from './es-ES/component';
import globalHeader from './es-ES/globalHeader';
import menu from './es-ES/menu';
import pages from './es-ES/pages';
import pwa from './es-ES/pwa';
import settingDrawer from './es-ES/settingDrawer';
import settings from './es-ES/settings';
import fixOverlay from './es-ES/fix_overlay';
import fixOpenapi from './es-ES/fix_openapi';
import fixAdminMisc from './es-ES/fix_adminmisc';
import fixBilling from './es-ES/fix_billing';
import fixComponents from './es-ES/fix_components';
import fixConsoleMisc from './es-ES/fix_consolemisc';
import fixGap from './es-ES/fix_gap';
import fixSystemconfig from './es-ES/fix_systemconfig';
import fixTenant from './es-ES/fix_tenant';
import fixVoiceClone from './es-ES/fix_voiceclone';
import fixTodo from './es-ES/fix_todo';


export default {
  'navBar.lang': 'Idiomas',
  'layout.user.link.help': 'Ayuda',
  'layout.user.link.privacy': 'Privacidad',
  'layout.user.link.terms': 'Términos',
  'app.preview.down.block': 'Descarga esta página a tu proyecto local',
  'app.welcome.link.fetch-blocks': 'Obtener todos los bloques',
  'app.welcome.link.block-list':
    'Construye rápidamente páginas estándar basadas en el desarrollo de `block`',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
};
